class NotifyMe extends HTMLElement {
    constructor() {
        super();

    }

    connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.productId = this.getAttribute('data-product-id');
        this.variantId = this.getAttribute('data-variant-id');
        this.email = this.form.querySelector('input[name="contact[email]"]');
        this.acceptPP = this.form.querySelector('input[name="contact[checkPrivacy]"]');
        this.submitBtn = this.form.querySelector('button[type="submit"]');
        this.submitBtnText = this.form.querySelector('button[type="submit"] span');
        this.loadingSpinner = this.querySelector('.notify-me-spinner');
        this.notifyInputs = this.querySelector('[data-notify-inputs]');


        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.create();
        });

        this.form.addEventListener('input', () => this.check());

        // Qui inizializzi la logica legata alla variante
        this.initVariantListener();
    }

    validateEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    showErrorBtn(submitBtn) {
        submitBtn.classList.add('submit__error');
        submitBtn.innerHTML = window.errorStrings.formInvalid;
    }

    removeErrorBtn(submitBtn) {
        submitBtn.classList.remove('submit__error');
    }

    check() {
        if (this.validateEmail(this.email.value) && this.acceptPP.checked) {
            this.submitBtn.removeAttribute("disabled");
        } else {
            this.submitBtn.setAttribute("disabled", '');
        }
    }

    async create() {
        const emailValue = this.email.value;
        const notifyVariant = parseInt(this.dataset.variantId, 10);
        const dataMessageValue = this.submitBtn.getAttribute('data-message');

        // Elementi
        const form = this.form;
        const successMessage = this.querySelector('#notifySuccess');
        const errorMessage = this.querySelector('#notifyError');

        // Stato iniziale: disabilita bottone, mostra loading
        this.submitBtn.disabled = true;
        this.submitBtnText.classList.add('tw-hidden');
        this.loadingSpinner.classList.remove('hidden');
        successMessage.classList.add('tw-hidden');
        errorMessage.classList.add('tw-hidden');

        try {
            const response = await BIS.create(emailValue, notifyVariant, this.productId);

            if (response.status === 'OK') {
                // Rimpiazza form con messaggio di successo
                this.loadingSpinner.classList.add('hidden');
                this.submitBtn.disabled = true;
                this.submitBtnText.classList.remove('tw-hidden');
                successMessage.classList.remove('tw-hidden');
                //this.subscribeCustomer(emailValue);
            } else {
                this.loadingSpinner.classList.add('hidden');
                this.submitBtn.disabled = false;
                this.submitBtnText.classList.remove('tw-hidden');
                errorMessage.classList.remove('tw-hidden');
            }
        } catch (err) {
            this.loadingSpinner.classList.add('hidden');
            this.submitBtn.disabled = false;
            this.submitBtnText.classList.remove('tw-hidden');
            errorMessage.classList.remove('tw-hidden');
        }
        //this.subscribeCustomer(emailValue);
    }

    subscribeCustomer(emailValue) {
        const payload = {
            email: emailValue,
        };
        if (window.customer) {
            if (window.customer.first_name) {
                payload.nome = window.customer.first_name;
            }
            if (window.customer.last_name) {
                payload.cognome = window.customer.last_name;
            }
        }
        publish(PUB_SUB_EVENTS.registerNewsletter, payload);
    }



    initVariantListener() {
        this.variant = null;

        const handleVariant = (variant) => {
            if (!variant) return;
            this.variant = variant;

            if (!variant.available) {
                this.classList.remove('tw-hidden');
            } else {
                this.classList.add('tw-hidden');
            }

            const announcements = document.querySelector('pdp-announcements');
            if (announcements) {
                announcements.classList.toggle('tw-hidden', !variant.available);
            }

            const buyButtons = document.querySelector('buy-buttons');
            if (buyButtons) {
                buyButtons.classList.toggle('tw-hidden', !variant.available);
            }

            this.dataset.variantId = variant.id;
            this.dataset.variantTitle = variant.title;
            this.dataset.variantPrice = variant.price;
            this.dataset.variantSku = variant.sku || '';
        };

        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            handleVariant(data.variant);
        });

        if (window.selectedVariant) {
            handleVariant(window.selectedVariant);
        }
    }
}

if (!customElements.get('notify-me')) {
    customElements.define('notify-me', NotifyMe);
}
